import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import kotlin.math.floor

@Composable
fun StatisticsScreen(onBack: () -> Unit) {
    var history by remember { mutableStateOf<List<TaskAttempt>>(emptyList()) }
    var isLoading by remember { mutableStateOf(true) }

    LaunchedEffect(Unit) {
        history = DataRepository.getHistory()
        isLoading = false
    }

    Div({
        style {
            padding(20.px)
            maxWidth(800.px)
            property("margin", "0 auto")
            fontFamily("Roboto, sans-serif")
        }
    }) {
        // Шапка
        Div({
            style {
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.SpaceBetween)
                alignItems(AlignItems.Center)
                marginBottom(30.px)
            }
        }) {
            H2({ style { color(Color("#2c3e50")); margin(0.px) } }) { Text("📊 Mi Progreso") }
            Button({
                style {
                    padding(10.px, 20.px)
                    backgroundColor(Color.white)
                    property("border", "1px solid #bdc3c7") // Заменил border(...) на property
                    borderRadius(20.px)
                    cursor("pointer")
                }
                onClick { onBack() }
            }) { Text("Volver") }
        }

        if (isLoading) {
            Div({ style { textAlign("center"); padding(50.px); color(Color("#7f8c8d")) } }) {
                Text("Cargando estadísticas...")
            }
        } else if (history.isEmpty()) {
            Div({ style { textAlign("center"); padding(50.px); backgroundColor(Color("#f8f9fa")); borderRadius(10.px) } }) {
                H3 { Text("Aún no tienes historial") }
                P { Text("Completa alguna tarea para ver tus resultados aquí.") }
            }
        } else {
            // Список карточек
            history.forEach { attempt ->
                HistoryCard(attempt)
            }
        }
    }
}

@Composable
fun HistoryCard(attempt: TaskAttempt) {
    var isExpanded by remember { mutableStateOf(false) }

    // Форматирование времени
    val minutes = floor(attempt.durationSeconds / 60.0).toInt()
    val seconds = attempt.durationSeconds % 60
    val timeString = "${minutes}m ${seconds.toString().padStart(2, '0')}s"

    // Оценка цвета (возвращаем String для безопасного использования в property)
    val percentage = (attempt.score.toDouble() / attempt.totalQuestions) * 100
    val statusColor = when {
        percentage >= 80 -> "#2ecc71" // Green
        percentage >= 50 -> "#f1c40f" // Yellow
        else -> "#e74c3c" // Red
    }

    Div({
        style {
            backgroundColor(Color.white)
            marginBottom(15.px)
            borderRadius(10.px)
            property("box-shadow", "0 2px 5px rgba(0,0,0,0.05)")

            // === ИСПРАВЛЕНИЕ: Используем property вместо borderLeft ===
            property("border-left", "5px solid $statusColor")

            overflow("hidden")
        }
    }) {
        // --- ЗАГОЛОВОК КАРТОЧКИ ---
        Div({
            onClick { isExpanded = !isExpanded }
            style {
                padding(15.px)
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.SpaceBetween)
                alignItems(AlignItems.Center)
                cursor("pointer")
                backgroundColor(if (isExpanded) Color("#f8f9fa") else Color.white)
            }
        }) {
            // Левая часть
            Div {
                H4({ style { margin(0.px); color(Color("#2c3e50")) } }) {
                    Text(attempt.setTitle)
                    Span({ style { fontSize(0.8.cssRem); color(Color("#95a5a6")); marginLeft(10.px); fontWeight("normal") } }) {
                        Text(attempt.createdAt?.substring(0, 10) ?: "")
                    }
                }
                Div({ style { fontSize(0.9.cssRem); color(Color("#7f8c8d")); marginTop(5.px) } }) {
                    Text("Tiempo: $timeString")
                }
            }

            // Правая часть
            Div({ style { textAlign("right") } }) {
                Div({ style { fontSize(1.5.cssRem); fontWeight("bold"); color(Color(statusColor)) } }) {
                    Text("${attempt.score}/${attempt.totalQuestions}")
                }
                Div({ style { fontSize(0.8.cssRem); color(Color("#95a5a6")) } }) {
                    Text(if (isExpanded) "▲ Ocultar" else "▼ Detalles")
                }
            }
        }

        // --- ДЕТАЛИ ---
        if (isExpanded) {
            Div({
                style {
                    padding(15.px)
                    // === ИСПРАВЛЕНИЕ: Используем property вместо borderTop ===
                    property("border-top", "1px solid #ecf0f1")
                }
            }) {
                attempt.details.forEachIndexed { index, detail ->
                    Div({
                        style {
                            marginBottom(10.px)
                            paddingBottom(10.px)
                            // === ИСПРАВЛЕНИЕ: Используем property вместо borderBottom ===
                            if (index < attempt.details.size - 1) {
                                property("border-bottom", "1px dashed #ecf0f1")
                            }
                        }
                    }) {
                        P({ style { fontWeight("bold"); margin(0.px); marginBottom(5.px); fontSize(0.95.cssRem) } }) {
                            Text("${index + 1}. ${detail.question}")
                        }

                        Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(5.px) } }) {
                            if (detail.isCorrect) {
                                Span({ style { color(Color("#27ae60")); fontSize(0.9.cssRem) } }) {
                                    Text("✅ Tu respuesta: ${detail.userAnswer}")
                                }
                            } else {
                                Span({ style { color(Color("#c0392b")); fontSize(0.9.cssRem) } }) {
                                    Text("❌ Tu respuesta: ${detail.userAnswer}")
                                }
                                Span({ style { color(Color("#27ae60")); fontSize(0.9.cssRem); fontWeight("bold") } }) {
                                    Text("💡 Correcto: ${detail.correctAnswer}")
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}